import CarrotClient from "../../../lib/carrot-api"
import Settings from "../../../utils/CarrotConfig"
import { useQuery, UseQueryResult } from "react-query"
import ResponseError from "../../../utils/ResponseError"
import { RetryConfig } from "utils/ErrorHandling"
const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const ENDPOINT = "GetEmployeeSprintsQualification"

export type SprintsCandidacyResponse = {
  memberIsSprintsCandidate: boolean
  partnerIsSprintsCandidate: boolean
}

export default function useGetSprintsCandidacy(
  employeeId: number
): UseQueryResult<SprintsCandidacyResponse, ResponseError> {
  return useQuery<SprintsCandidacyResponse, ResponseError>(
    [ENDPOINT, employeeId],
    () => client.getEmployeeSprintsCandidacy(employeeId),
    {
      ...RetryConfig
    }
  )
}
